<template>
  <div class="flightDetailVedioContainer" id="flightDetailVedioContainer">
    <div class="titleRow">
      <img :src="videoImg" class="videoImg" />
      <label class="videoLabel">视频直播</label>
    </div>
    <div class="videoPlayContainer"></div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="planImg" class="planImg" />
      <label class="planLabel">计划编号</label>
    </div>
    <div class="planInfoContainer">
      <div class="localId">{{ taskPlan.local_id }}</div>
      <div>-</div>
      <div class="createTime">创建时间：{{ taskPlan.created_at }}</div>
      <div class="submitId">提交账号：{{ taskPlan.user_no }}</div>
      <div class="priority">
        优先级：
        <div class="priorityDiv">
          <img :src="minimum" class="minimum" @click="choosePriority(1)" />
          <div class="prioritySeperate"></div>
          <img :src="secondary" class="secondary" @click="choosePriority(2)" />
          <div class="prioritySeperate"></div>
          <img :src="highest" class="highest" @click="choosePriority(3)" />
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="timerImg" class="timerImg" />
      <label class="timerLabel">投送时间</label>
    </div>
    <div class="timerContainer">
      <div>
        <label class="title">开始时间：</label
        ><label class="content">{{ taskPlan.start_at }}</label>
      </div>
      <div>
        <label class="title">结束时间：</label
        ><label class="content">{{ taskPlan.end_at }}</label>
      </div>
    </div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="stayPointImg" class="stayPointImg" />
      <label class="stayPointLabel">驻点选择</label>
    </div>
    <div class="stayPointContainer">
      <div class="stayPointTitleRow">起点:&nbsp;{{ starstaypoint.name }}</div>
      <div class="titleLon">
        <label class="title">Lon:&nbsp;</label
        ><label class="content">{{ starstaypoint.longitude }}</label>
      </div>
      <div class="titleLat">
        <label class="title">Lat:&nbsp;</label
        ><label class="content">{{ starstaypoint.latitude }}</label>
      </div>
      <div class="titleAlt">
        <label class="title">Alt:&nbsp;</label
        ><label class="content">{{ starstaypoint.altitude }}m</label>
      </div>
      <div class="stayPointTitleRow">终点:&nbsp;{{ endstaypoint.name }}</div>
      <div class="titleLon">
        <label class="title">Lon:&nbsp;</label
        ><label class="content">{{ endstaypoint.longitude }}</label>
      </div>
      <div class="titleLat">
        <label class="title">Lat:&nbsp;</label
        ><label class="content">{{ endstaypoint.latitude }}</label>
      </div>
      <div class="titleAlt">
        <label class="title">Alt:&nbsp;</label
        ><label class="content">{{ endstaypoint.altitude }}m</label>
      </div>
    </div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="uavImg" class="uavImg" />
      <label class="uavLabel">无人机选择</label>
    </div>
    <div class="uavContainer">
      <div>
        <label class="title">最大载重:&nbsp;</label
        ><label class="content">{{ uavmodel.max_payload }}kg</label>
      </div>
      <div>
        <label class="title">货舱体积:&nbsp;</label
        ><label class="content">{{ uavmodel.cargo_hold_volume }}cm³</label>
      </div>
      <div>
        <label class="title">满载航时:&nbsp;</label
        ><label class="content">{{ uavmodel.max_fly_time }}min</label>
      </div>
      <div>
        <label class="title">机载通讯:&nbsp;</label
        ><label class="content">{{ uav.airborne_communication_name }}</label>
      </div>
      <div>
        <label class="title">所在机场:&nbsp;</label
        ><label class="content">{{ uavmodel.cargo_hold_volume }}</label>
      </div>
    </div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="goodsImg" class="goodsImg" />
      <label class="goodsLabel">货物匹配</label>
    </div>
    <div class="goodsContainer">
      <div v-for="good in lsgoods">
        <label class="content">{{ good }}</label>
      </div>
    </div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="linkImg" class="linkImg" />
      <label class="linkLabel">链路规划</label>
    </div>
    <div class="linkContainer">
      <div>
        <label class="title">型号:&nbsp;</label
        ><label class="content">{{ airlink.name }}</label>
      </div>
      <div>
        <label class="title">类型:&nbsp;</label
        ><label class="content">{{ airlink.typeName }}</label>
      </div>
      <div>
        <label class="title">频点:&nbsp;</label
        ><label class="content">{{ airlink.frequency }}</label>
      </div>
      <div>
        <label class="title">通讯站:&nbsp;</label
        ><label class="content">{{ airlink.com_station_name }}</label>
      </div>
    </div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="routeImg" class="routeImg" />
      <label class="routeLabel">航路规划</label>
    </div>
    <div class="routeContainer">
      <div>
        <label class="title">编号:&nbsp;</label
        ><label class="content">{{ taskPlan.airline_name }}</label>
      </div>
      <div>
        <label class="title">创建时间:&nbsp;</label
        ><label class="content">{{ taskPlan.created_at }}</label>
      </div>
      <div>
        <label class="title">航线长度:&nbsp;</label
        ><label class="content">{{ taskPlan.total_mileage }}km</label>
      </div>
      <div>
        <label class="title">航点个数:&nbsp;</label
        ><label class="content">{{ taskPlan.point_count }}</label>
      </div>
    </div>
    <div class="separator"></div>
    <div class="titleRow">
      <img :src="personImg" class="personImg" />
      <label class="personLabel">指派人员</label>
    </div>
    <div class="personContainer">
      <div>
        <label class="title">发货地勤:&nbsp;</label
        ><label class="content">{{ taskPlan.customer_groundstaf_name }}</label>
      </div>
      <div>
        <label class="title">收货地勤:&nbsp;</label
        ><label class="content">{{ taskPlan.destination_groundstaf_name }}</label>
      </div>
      <div>
        <label class="title">保障员:&nbsp;</label
        ><label class="content">{{ taskPlan.security_name }}</label>
      </div>
      <div>
        <label class="title">飞手:&nbsp;</label
        ><label class="content">{{ taskPlan.flyer_name }}</label>
      </div>
      <div>
        <label class="title">任务控制员:&nbsp;</label
        ><label class="content">{{ taskPlan.task_controller_name }}</label>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import videoImg from "../../../assets/img/home/flightDetail/videoImg.png";
import planImg from "../../../assets/img/home/flightDetail/planImg.png";
import timerImg from "../../../assets/img/home/flightDetail/timerImg.png";
import stayPointImg from "../../../assets/img/home/flightDetail/stayPointImg.png";
import uavImg from "../../../assets/img/home/flightDetail/uavImg.png";
import goodsImg from "../../../assets/img/home/flightDetail/goodsImg.png";
import linkImg from "../../../assets/img/home/flightDetail/linkImg.png";
import routeImg from "../../../assets/img/home/flightDetail/routeImg.png";
import personImg from "../../../assets/img/home/flightDetail/personImg.png";

import minimum from "../../../assets/img/home/minimum.png";
import minimumUnchecked from "../../../assets/img/home/minimumUnchecked.png";
import secondary from "../../../assets/img/home/secondary.png";
import secondaryUnchecked from "../../../assets/img/home/secondaryUnchecked.png";
import highest from "../../../assets/img/home/highest.png";
import highestUnchecked from "../../../assets/img/home/highestUnchecked.png";

export default {
  name: "flightDetailVedio",
  data() {
    return {
      starstaypoint: {},
      endstaypoint: {},
      uav: {},
      uavmodel: {},
      lsgoods: [],
      airlink: {},
      videoImg: videoImg,
      planImg: planImg,
      timerImg: timerImg,
      stayPointImg: stayPointImg,
      timerImg: timerImg,
      uavImg: uavImg,
      goodsImg: goodsImg,
      linkImg: linkImg,
      routeImg: routeImg,
      personImg: personImg,
      minimum: minimumUnchecked,
      secondary: secondaryUnchecked,
      highest: highestUnchecked,
      linkTypes: [
        {
          id: 0,
          name: "M4G",
        },
        {
          id: 1,
          name: "J4G",
        },
        {
          id: 2,
          name: "M5G",
        },
        {
          id: 3,
          name: "J5G",
        },
        {
          id: 4,
          name: "电台",
        },
        {
          id: 5,
          name: "卫通",
        },
      ],
    };
  },
  props: ["taskPlan"],
  methods: {
    choosePriority(priority) {
      if (1 === priority) {
        this.minimum = minimum;
        this.secondary = secondaryUnchecked;
        this.highest = highestUnchecked;
      } else if (2 === priority) {
        this.minimum = minimumUnchecked;
        this.secondary = secondary;
        this.highest = highestUnchecked;
      } else if (3 === priority) {
        this.minimum = minimumUnchecked;
        this.secondary = secondaryUnchecked;
        this.highest = highest;
      } else {
        this.minimum = minimumUnchecked;
        this.secondary = secondaryUnchecked;
        this.highest = highestUnchecked;
      }
    }, //查询用户
    queryTaskPlanUser(taskPlan, id) {
      let vue = this;
      this.postJsonRequest("/user-server/api/u-user/getUsersByCondition", {
        idList: [id],
      }).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          let data = oData.data;
          if (!this.isEmptyArray(data) && id == data[0].id) {
            this.$set(taskPlan, "user_no", data[0].userNo);
          }
        }
      });
    },
    initData() {
      this.$data.starstaypoint = {};
      this.$data.endstaypoint = {};
      this.$data.uav = {};
      this.$data.uavmodel = {};
      this.$data.lsgoods = [];
      this.$data.airlink = {};
    },
    setData(val) {
      //设置优先级
      this.choosePriority(val.priority);
      //查询用户
      if (val.user_id) {
        this.queryTaskPlanUser(val, val.user_id);
      }
      if (val.starstaypoint) {
        this.$data.starstaypoint = { ...val.starstaypoint };
        this.formatStayPoint(this.$data.starstaypoint);
      }
      if (val.endstaypoint) {
        this.$data.endstaypoint = { ...val.endstaypoint };
        this.formatStayPoint(this.$data.endstaypoint);
      }
      if (val.uav) {
        this.$data.uav = { ...val.uav };
        if (val.uav.uavmodel) {
          this.$data.uavmodel = { ...val.uav.uavmodel };
        }
      }
      if (!this.isEmptyArray(val.lsgoods)) {
        const tempLsgoods = val.lsgoods;
        const lsgoods = (this.$data.lsgoods = []);
        for (let index = 0; index < tempLsgoods.length; index++) {
          const element = tempLsgoods[index];
          lsgoods.push(element.local_id);
        }
      }
      if (val.airlink) {
        this.$data.airlink = val.airlink;
        if (null != this.$data.airlink.type) {
          this.$data.airlink.typeName = this.$data.linkTypes[
            this.$data.airlink.type
          ].name;
        }
      }
      try {
        if (!this.isEmptyStr(val.task_coordinate_waypoints)) {
          const points = val.task_coordinate_waypoints.split(";");
          val.point_count = points.length;
        }
      } catch (error) {}
      if (val.customer_groundstaf) {
        this.taskPlan.customer_groundstaf_name = val.customer_groundstaf.username;
      }
      if (val.destination_groundstaf) {
        this.taskPlan.destination_groundstaf_name = val.destination_groundstaf.username;
      }
      if (val.security) {
        this.taskPlan.security_name = val.security.username;
      }
      if (val.flyer) {
        this.taskPlan.flyer_name = val.flyer.username;
      }
      if (val.task_controller) {
        this.taskPlan.task_controller_name = val.task_controller.username;
      }
      this.$forceUpdate();
    },
    formatStayPoint(point) {
      try {
        if (point.longitude) {
          point.longitude = point.longitude.fixed(6);
        }
        if (point.latitude) {
          point.latitude = point.latitude.fixed(6);
        }
        if (point.altitude) {
          point.altitude = point.altitude.fixed(2);
        }
      } catch (error) {}
    },
  },
  mounted() {},
  watch: {
    taskPlan: function (nval, oval) {
      if (nval.id) {
        this.setData(nval);
      } else {
        this.initData();
      }
    },
  },
  computed: {},
  components: {},
  beforeDestroy() {},
};
</script>

<style scoped>
@import "../../../assets/css/home/flightDetail/flightDetailVedio.css";
</style>

<style></style>



// WEBPACK FOOTER //
// src/components/home/flightDetail/flightDetailVedio.vue